import React, { useState } from "react";
export function useStatefulRef(initialVal = null) {
	let [currentVal, setCurrentVal] = useState(initialVal);

	const [statefulRef] = useState({
		get current() {},
		set current(value) {},
	});
	Object.defineProperty(statefulRef, "current", {
		get: () => currentVal,
		set: (newValue) => {
			if (!Object.is(currentVal, newValue)) {
				currentVal = newValue;
				setCurrentVal(currentVal);
			}
		},
	});
	return statefulRef;
}
